import { render, staticRenderFns } from "./deptInfoList.vue?vue&type=template&id=3c1f1218&scoped=true"
import script from "./deptInfoList.vue?vue&type=script&lang=js"
export * from "./deptInfoList.vue?vue&type=script&lang=js"
import style0 from "./deptInfoList.vue?vue&type=style&index=0&id=3c1f1218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f1218",
  null
  
)

export default component.exports